module.exports = __webpack_public_path__ + "img/fill-arrow-right.df129b07.svg";